import React from 'react'
import clsx from 'clsx'
import debounce from 'debounce'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import useSearchResults from 'app/SearchPage/hooks/useSearchResults'
import useSETrackEvent from 'app/SearchPage/hooks/useSETrackEvent'

const ScrollToTop = () => {
  const [prevScrollPos, setPrevScrollPos] = React.useState(0)
  const [visible, setVisible] = React.useState(false)
  const { SETrackSearchResultsPage } = useSETrackEvent()
  const { searchResultsCount, lastPageNumber } = useSearchResults()

  const handleScroll = debounce(() => {
    const currentScrollPos = window.pageYOffset
    setVisible(prevScrollPos > currentScrollPos && currentScrollPos > 50)
    setPrevScrollPos(currentScrollPos)
  }, 50)

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  return (
    <div
      className={clsx(
        'transition-transform fixed bottom-0 left-0 right-0 flex justify-center max-w-xl pb-4 mx-auto',
        !visible && 'translate-y-20'
      )}
    >
      <Button
        color="blue"
        className="!rounded-full !shadow-lg"
        onClick={() => {
          SETrackSearchResultsPage('TOP_PAGE_SEARCH_RESULTS', {
            num_results: [searchResultsCount, 'int'],
            page_num: [lastPageNumber, 'int'],
          })
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }}
      >
        <Icon color="inverse">arrow_upward</Icon>&nbsp;Ke paling atas
      </Button>
    </div>
  )
}

export default ScrollToTop
